import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'

export interface EmptyState {
  icon: React.ReactNode
  emoji?: string
  title: string
  description: string
}

export interface CardGridProps<T> {
  items: T[]
  emptyState: EmptyState
  renderCard: (item: T) => React.ReactNode
  getItemLink: (item: T) => string
  getItemKey: (item: T) => string
}

export function CardGrid<T>({
  items,
  emptyState,
  renderCard,
  getItemLink,
  getItemKey,
}: CardGridProps<T>) {
  const isEmpty = items.length === 0

  return (
    <div>
      {isEmpty ? (
        <Card>
          <CardContent className="flex min-h-[200px] flex-col items-center justify-center p-8 text-center">
            {/* Icon Container - Centered with background */}
            <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#0033A0]/10">
              {emptyState.emoji ? (
                <span className="text-4xl">{emptyState.emoji}</span>
              ) : (
                <div className="text-[#0033A0]">{emptyState.icon}</div>
              )}
            </div>

            {/* Title */}
            <p className="mb-1 text-base font-semibold text-black">
              {emptyState.title}
            </p>

            {/* Description */}
            <p className="text-sm text-[#666666]">{emptyState.description}</p>
          </CardContent>
        </Card>
      ) : (
        <div className="scrollbar-hide -mx-4 flex gap-4 overflow-x-auto px-4 sm:-mx-6 sm:px-6">
          {items.map(item => (
            <Link
              key={getItemKey(item)}
              to={getItemLink(item)}
              className="block w-[calc(85vw-2rem)] flex-shrink-0 sm:w-[280px]"
            >
              <Card className="h-full transition-shadow hover:shadow-md">
                <CardContent className="p-3">{renderCard(item)}</CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
